import React, { useEffect, useState } from "react";
import ButtonGeneric from "../../../components/Buttons/ButtonGeneric";
import RadioGroupGeneric from "../../../components/Inputs/RadioGroupGeneric";
import {
  optionsBs,
  optionsDolares,
  typePayments,
} from "../../../propsType/Payemnts";
import { validateTypePayments } from "../../../validations/formValidations";
import { useForm } from "../../../Hooks/UseForm";
import Modal from "../../../components/Modals/Modal";

function Step3({
  stapsState,
  setStapsState,
  deatils,
  stespData,
  setStespData,
}) {
  const { form, errors, handleChange, handleSubmit, handleBlur } = useForm(typePayments, validateTypePayments);
  // Estado que define el tipo de moneda seleccionado
  const [op, setOp] = useState(stespData.data.title === "Bolívares" ? optionsBs : optionsDolares || "");
  const [formSleccion, setFormSleccion] = useState({ payments: "" });
  const [errorSeleccion, setErrorSeleccion] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [msgModal, setMsgModal] = useState("");

  const metodoPago = () => {
    setErrorSeleccion(false);
    setStespData({
      ...stespData,
      metodoPago: formSleccion.payments || stespData.metodoPago,
    });
    setStapsState({
      ...stapsState,
      option1: false,
      option2: false,
      option3: false,
      option4: true,
      option5: false,
    });
  }
  const siguiente = () => {
    if (!formSleccion.payments) {
      setErrorSeleccion(true);
    }
    else {
      let montoApagar = stespData.metodoAPagar;
      let deuda = (stespData.data.title === "Bolívares" ? deatils.deudaTotalVEF : deatils.deudaTotalUSD);

      montoApagar = parseFloat(montoApagar);
      deuda = parseFloat(deuda);

      if (stespData.data.title === "Bolívares") {
        switch (formSleccion.payments.title) {
          case "Pago Móvil":
            metodoPago(); break;
          case "Débito Nacional":
          case "Crédito Nacional":
            if ((deuda > 0) && (montoApagar < deuda)) { setShowModal(true); setMsgModal("El monto debe ser igual o mayor a tu deuda."); }
            else if (montoApagar < 1) { setShowModal(true); setMsgModal("El monto debe ser mayor a Bs 1."); }
            else { metodoPago() } break;
          case "Master Debit":
            if ((deuda > 0) && (montoApagar < deuda)) { setShowModal(true); setMsgModal("El monto debe ser igual o mayor a tu deuda."); }
            else if (montoApagar < 1) { setShowModal(true); setMsgModal("El monto debe ser mayor a Bs 1."); }
            else { metodoPago() } break;
          default: break

        }
      }
      else {
        switch (formSleccion.payments.title) {
          case "Zelle":
            metodoPago(); break;
          case "Tarjeta Internacional":

            let deudaCliente = parseFloat(deuda);
            let monto = parseFloat(montoApagar);
            if ((deudaCliente > 0) && (monto < deudaCliente)) { setShowModal(true); setMsgModal("El monto debe ser igual o mayor a tu deuda."); }
            else if ((deudaCliente > 0) && (monto >= deudaCliente) && (monto < 4000)) { metodoPago(); }
            else if (monto < 10 || monto > 4000) { setShowModal(true); setMsgModal("El monto debe ser mayor a USD 10 y menor a USD 4000"); }
            else { metodoPago() }
            break;
        }

      }

    }
  };
  const handleSeleccion = (e) => {
    setFormSleccion({ ...formSleccion, payments: e });
  };
  const atras = () => {
    setStespData({
      ...stespData,
      back: true,
    });
    setStapsState({
      ...stapsState,
      option1: false,
      option2: true,
      option3: false,
      option4: false,
      option5: false,
    });
  };

  useEffect(() => {
    if (formSleccion.payments !== "") {
      setErrorSeleccion(false);
    }
  }, [formSleccion]);

  return (
    <div className="w-full flex-col flex gap-5 ">
      <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
        <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div className="ml-4 mt-4">
            <h3 className="text-2xl leading-6 font-medium text-gray-900">
            Medio de Pago
            </h3>
            <p className="mt-1 text-sm text-gray-500">
              Selecciona el medio por el cual deseas pagar
            </p>
          </div>
        </div>
      </div>
      <div className="p-5">
        <RadioGroupGeneric
          numberCol={4}
          flex={stespData.data.title === "Bolívares" ? false : true}
          image={"yes"}
          value={formSleccion.payments}
          setValue={handleSeleccion}
          array={op}
          error={errorSeleccion}

        />
      </div>
      <Modal
        active={showModal}
        setActive={setShowModal}
        string={"error"}
        message={msgModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <button
            type="button"
            onClick={atras}
            className="inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
          >
            Volver
          </button>
        </div>
      </Modal>
      <div className="w-full flex justify-between  gap-[50%] p-5">
        <div className="w-full">
          <ButtonGeneric funtion={atras} text={"Volver"} />
        </div>
        <div className="w-full">
          <ButtonGeneric funtion={siguiente} text={"Siguiente"} />
        </div>
      </div>
    </div>
  );
}

export default Step3;
